/* eslint-disable */
import enJson from './en.json';
import jaJson from './ja.json';
import koJson from './ko.json';
import zh_hantJson from './zh-hant.json';
import zh_hansJson from './zh-hans.json';
import thJson from './th.json';
import deJson from './de.json';
import esJson from './es.json';
import frJson from './fr.json';
import ptJson from './pt.json';
import ruJson from './ru.json';
import trJson from './tr.json';
import huJson from './hu.json';
import itJson from './it.json';
import nlJson from './nl.json';

export default {
  'en': enJson,
  'ja': jaJson,
  'ko': koJson,
  'zh-hant': zh_hantJson,
  'zh-hans': zh_hansJson,
  'th': thJson,
  'de': deJson,
  'es': esJson,
  'fr': frJson,
  'pt': ptJson,
  'ru': ruJson,
  'tr': trJson,
  'hu': huJson,
  'it': itJson,
  'nl': nlJson,
};
